<template>
  <div :class="['grid-wrapper']">
    <div class="cover" v-if="loading" >
      <smd-loading-dots/>
    </div>
    <template v-else>
      <div ref="sidebar" :class="['sidebar', sidebarStyles]">
        <slot name="sidebar"/>
      </div>
      <div ref="content" :class="['content', contentStyles]">
        <slot name="content"/>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "two-column-layout",
    props: {
      loading: {type: Boolean, default: false},
      contentStyles: {type: Array, required: false},
      sidebarStyles: {type: Array, required: false}
    }
  }
</script>

<style scoped lang="scss">
  @import 'scss/pogs-util';

  %sidebar-right {
    grid-template-columns: 1fr auto;
    grid-template-areas: 'content sidebar';
  }

  .page__content > .grid-wrapper{
    .content,
    .sidebar{
      @extend %independent-layout-container,%hide-overflow;
      & > .page{
        @extend %independent-layout;
      }
    }
  }

  .content {
    @extend %overflow-y-auto;
    grid-area: content;
  }

  .sidebar {
    @extend %overflow-y-auto;
    grid-area: sidebar;

    @include transition(width 0.25s cubic-bezier(.17,.67,.84,.71));

    width: 300px;
    z-index: 100;

    @include responsive(tablet) {
      width: 200px;
    }

    @include responsive(mobile) {
      height: 100vh;
      width: 100%;
      overflow: hidden;

      @include transition(height 0.3s cubic-bezier(.17,.67,.84,.71));
    }
  }

  .grid-wrapper {
    @extend %independent-layout, %hide-overflow;
    @include make-grid-cols(auto 1fr);

    background: white;

    width: 100%;
    height: 100%;

    grid-template-areas: 'sidebar content';

    .dark {
      background: color(light, light-bg);
    }

    &.hide-content{
      grid-template-columns: auto 0;

      .sidebar{
        width: 100%;
      }
    }

    &.show-content{

      .sidebar{
        width: 400px;
        @include transition(none);
      }

      .content{
        @extend %independent-layout;
        background: color(light,light-bg);
        overflow: visible;
        z-index: 1000;

        & > div:first-child{
          @extend .right-shadow, %hide-overflow;

          border-top-left-radius: radius(large);
          border-bottom-left-radius: radius(large);
          background: color(base,light-bg);
        }
      }
    }


    &.hide-sidebar {

      &.sb-min-180 {
        .sidebar {
          width: 180px !important;

          @include responsive(tablet) {
            width: 120px !important;
          }

          @include responsive(mobile) {
            height: 50px !important;
          }
        }

        .flex-center{
          margin-left: -180px;
        }
      }

      .sidebar {
        width: 0 !important;

        @include responsive(mobile) {
          height: 0 !important;
        }
      }

    }

    &.s-sidebar {
      .sidebar {
        width: 200px;
      }
    }

    &.m-sidebar {
      .sidebar {
        width: 400px;
        @include responsive(tablet) {
          width: 300px;
        }
      }
    }

    &.sidebar-right {
      @extend %sidebar-right;
    }

    @include responsive(mobile) {
      grid-template-rows: auto 1fr !important;
      grid-template-columns: auto !important;
      grid-template-areas: 'sidebar' 'content';
    }
  }

  .right-shadow {
    box-shadow: 0 0 15px color(label);
  }

  .show-overflow{
    @extend %show-overflow;
  }

  .pseudo-dialog{
    @extend %border-radius-normal;
    @include calc('height', '100% - ' + space(s)*2);
    @include calc('width', '100% - ' + space(s)*2);

    background: white;
    filter: drop-shadow(0px 0px 12px rgba(33, 33, 33, .25));
    margin: space(10px);

    &:after{
      content: ' ';
      background: white;
      height: 15px;
      width: 15px;
      transform: rotate(45deg);
      position: absolute;
      top: 80px;
      right: -8px;
      z-index: 1000;
    }
  }

</style>